import { useRef, useState } from 'react';

export const useExpandableWrapper = () => {
  const [childHeight, setChildHeight] = useState<string | number>(0);
  const ref = useRef<HTMLDivElement>(null);

  const onEnterOrExit = (): void => {
    if (ref.current !== null) {
      setChildHeight(ref.current.offsetHeight);
    }
  };

  const onEntered = (): void => {
    setChildHeight('auto');
  };

  const onExiting = (): void => {
    setChildHeight(0);
  };

  const state = {
    childHeight,
    ref,
  };

  return {
    onEnterOrExit,
    onEntered,
    onExiting,
    state,
  };
};
